import { forwardRef, RefObject, useEffect } from 'react';

import { useSelector } from 'react-redux';

import ReduxState from 'store/ReduxState';

import { CurrentlyPlaying } from './hls-helper';

const setAttributes = ({
  audioRef,
  currentlyPlaying,
}: {
  audioRef: RefObject<HTMLAudioElement>;
  currentlyPlaying: CurrentlyPlaying;
}) => {
  const { id, type, audioType } = currentlyPlaying;
  let title;

  if (audioType === 'teaser') {
    if (type === 'speaker') {
      title = `SpeakerTeaser: ${id}`;
    } else if (type === 'story') {
      title = `StoryTeaser: ${id}`;
    } else {
      title = `OtherTeaser: ${id}`;
    }
  } else {
    title = `Story: ${id}`;
  }

  if (audioRef.current) {
    audioRef.current.dataset.matomoResource = window.location.href;
    audioRef.current.dataset.matomoTitle = title;
  }
};

export const updateMatomoAttributes = ({
  audioRef,
  currentlyPlaying,
}: {
  audioRef: RefObject<HTMLAudioElement>;
  currentlyPlaying: CurrentlyPlaying | undefined;
}) => {
  if (audioRef && audioRef.current) {
    if (currentlyPlaying) {
      setAttributes({ audioRef, currentlyPlaying });
    } else {
      delete audioRef.current.dataset.matomoResource;
      delete audioRef.current.dataset.matomoTitle;
    }
  }
};

const MatomoHandler = forwardRef(
  (_props, audioRef: RefObject<HTMLAudioElement>) => {
    const currentlyPlaying = useSelector<
      ReduxState,
      CurrentlyPlaying | undefined
    >(({ player }) => player.currentlyPlaying);

    useEffect(() => {
      updateMatomoAttributes({
        audioRef,
        currentlyPlaying,
      });
    }, [audioRef, currentlyPlaying]);

    return null;
  },
);

export default MatomoHandler;
